/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CitaModelDto } from '../../models/cita-model-dto';

export interface CitasControllerObtencionCita$Params {

/**
 * UUID de la cita a obtener
 */
  uuidCita: string;
}

export function citasControllerObtencionCita(http: HttpClient, rootUrl: string, params: CitasControllerObtencionCita$Params, context?: HttpContext): Observable<StrictHttpResponse<CitaModelDto>> {
  const rb = new RequestBuilder(rootUrl, citasControllerObtencionCita.PATH, 'get');
  if (params) {
    rb.path('uuidCita', params.uuidCita, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CitaModelDto>;
    })
  );
}

citasControllerObtencionCita.PATH = '/api/citas/obtener-cita/{uuidCita}';
